export default __webpack_public_path__ + "static/media/bgMob.cc3f968a.png";